import React from 'react'
import { connect } from 'react-redux'
import throttle from 'lodash/throttle'

import {
  getIsLoggedIn,
  getRawUserName,
  getUserEmail,
} from 'selectors/authSelectors'

import { getRooftopName } from 'selectors/appStatusSelectors'

const injectScriptTag = () => {
  let d = window.document,
    lastScriptTag = d.getElementsByTagName('script')[0],
    scriptTag = d.createElement('script')

  scriptTag.async = true
  scriptTag.src = 'https://js.hs-scripts.com/7186551.js'

  lastScriptTag.parentNode.insertBefore(scriptTag, lastScriptTag)
}

const bootstrap = ({ name, email, isLoggedIn, rooftopName }) => {
  if (!isLoggedIn) return null

  let _hsq = (window._hsq = window._hsq || [])

  _hsq.push([
    'identify',
    {
      email,
      firstname: name.firstName,
      lastname: name.lastName,
      rooftop: rooftopName,
    },
  ])

  _hsq.push(['trackPageView'])

  injectScriptTag()
}

export class HubspotChat extends React.Component {
  state = { mounted: false }

  componentDidUpdate() {
    if (!this.state.mounted && this.props.isLoggedIn && this.props.email) {
      this.setState({ mounted: true }, throttle(() => bootstrap(this.props), 1))
    }
  }

  render() {
    return null
  }
}

function mapStateToProps(state, op) {
  return {
    ...op,
    isLoggedIn: getIsLoggedIn(state),
    email: getUserEmail(state),
    name: getRawUserName(state) || {},
    rooftopName: getRooftopName(state),
  }
}

export default connect(mapStateToProps)(HubspotChat)
